import Api from './api.service'

export const uploadFile = (url, file, params, onUploadProgress) => {
    let formData = new FormData();
    formData.append("files[]", file);
    for (let key in params) {
        formData.append(key, params[key]);
    }

    return Api().post(url, formData, {
        headers: {
            "Content-Type": "multipart/form-data",
        },
        onUploadProgress,
    });
};